/*
Layout used by embeddable popups.
*/
import clsx from 'clsx'

import classes from './OpenInNewTabButton.module.css'

/*
 * Helper button to open popup in new window for easier development.
 */
export default function OpenInNewTabButton({ className }: { className?: string }) {
  const isInsideIframe = typeof window !== 'undefined' && window?.parent !== window
  const isDevelopment = process.env.NODE_ENV === 'development'

  if (!isInsideIframe || !isDevelopment) {
    return null
  }
  return (
    <button
      className={clsx(classes.openInNewTabButton, className)}
      onClick={() => {
        const url = location.href
        // FIXME: strictNullCheck temporary fix
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        window.open(url, '_blank').focus()
      }}
      title='Open window in new tab'
    >
      <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2 5.3C2 3.5 3.5 2 5.3 2h11.4C18.6 2 20 3.5 20 5.3V8l-1.5.1V7h-15v9.8c0 1 .8 1.7 1.8 1.7h8l-.5.8-.3.7H5.2A3.3 3.3 0 0 1 2 16.7V5.3Zm3.3-1.8c-1 0-1.8.8-1.8 1.8v.2h15v-.3c0-1-.8-1.7-1.8-1.7H5.3ZM19.9 9a3.5 3.5 0 0 0-3.2 5.5l-3 5.3a1.5 1.5 0 1 0 2.5 1.4l3-5.2a3.5 3.5 0 0 0 3-5.8l-1.7 2.9a1.2 1.2 0 1 1-2-1.2L20.2 9h-.3Zm-9.6.2c.3.3.3.8 0 1.1l-2.4 2.2 2.4 2.2a.8.8 0 0 1-1 1.1l-3-2.7a.8.8 0 0 1 0-1.2l3-2.7c.2-.3.7-.3 1 0Zm3 6.6 2-1.8c-.3-1-.4-2 0-3l-2-1.8a.8.8 0 0 0-1 1.1l2.3 2.2-2.4 2.2a.8.8 0 0 0 1 1.1Z'
          fill='currentColor'
        />
      </svg>
    </button>
  )
}
